import React from 'react';
import { Box, createStyles, makeStyles, TextField, Typography } from '@material-ui/core';
// Стили совпадают с формами системы.
const useStyles = makeStyles(() => createStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        width: '800px',
        padding: '72px',
    },
    header: {
        fontWeight: 600,
        marginBottom: '32px',
    },
    subheader: {
        fontWeight: 600,
        marginTop: '16px',
        marginBottom: '16px',
    },
    input: {
        width: '370px',
        marginBottom: '16px',
    },
    actions: {
        marginTop: '16px',
    },
}));
export const InstanceView = ({ instanceDetails, actions }) => {
    const styles = useStyles();
    const mainRows = [
        { label: 'Идентификатор', value: instanceDetails.guid },
        { label: 'Название агента', value: instanceDetails.name },
        { label: 'Статус агента', value: instanceDetails.stateName },
        { label: 'Заголовок HTTP', value: instanceDetails.httpHeader },
        { label: 'Адрес', value: instanceDetails.host },
        { label: 'Порт', value: instanceDetails.port },
    ];
    const headRows = [
        { label: 'Заголовок HTTP Head', value: null },
        { label: 'Хост Head', value: null },
    ];
    // Редактирование агента бэкенд не поддерживает - все поля только для чтения.
    const renderRow = ({ label, value }) => (React.createElement(TextField, { key: label, className: styles.input, variant: "outlined", label: label, value: value === null ? '' : value || '—', InputProps: { readOnly: true }, InputLabelProps: { shrink: true } }));
    return (React.createElement(Box, { className: styles.root },
        React.createElement(Typography, { className: styles.header, variant: "h4", component: "h2" }, "\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u043E\u0431 \u0430\u0433\u0435\u043D\u0442\u0435"),
        mainRows.map(renderRow),
        React.createElement(Typography, { className: styles.subheader, variant: "h6", component: "h3" }, "Head"),
        headRows.map(renderRow),
        actions && (React.createElement(Box, { className: styles.actions, display: "flex", alignItems: "center" }, actions))));
};
